import { getCookie, setCookie, removeCookie } from "../tools/cookie-manager";
import { TOKEN, IS_LOGIN , DEVICE_UNIQUE_ID, SESSION_KEY_ID, TOKEN_EXPIRATION_TIME} from "../tools/cookies"
import { isMobile, mobileVendor, osName, osVersion, mobileModel } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';

export function setSessionKeyId(sessionKeyId){
  setCookie(SESSION_KEY_ID, sessionKeyId, 9999)
}

export function getSessionKeyId(){
  return getCookie(SESSION_KEY_ID)
}

export function setToken(token, expirationTime){
  setCookie(TOKEN, token, 9999);
  setCookie(TOKEN_EXPIRATION_TIME, expirationTime, 9999);
}

export function login() {
  localStorage.setItem(IS_LOGIN, true);
}

export function logout() {
  // console.log("logout")
  removeCookie(TOKEN);
  removeCookie(TOKEN_EXPIRATION_TIME);
  removeCookie(SESSION_KEY_ID);
  removeCookie(IS_LOGIN)
  localStorage.setItem(IS_LOGIN, false);
  window.location.reload();
}

export function token() {
  const value = getCookie(TOKEN);
  return value;
}

export function isLogin() {
  const value = localStorage.getItem(IS_LOGIN);
  return value;
}

export function getDeviceName(){
  var deviceName = null
  if (isMobile){
    deviceName = mobileVendor + " - " + mobileModel
  } else {
    deviceName = "PC"
  }
  return deviceName;
}

export function getOs(){
  return osName;
}

export function getOsVersion(){
  return osVersion;
}

export function getDeviceUniqueId(){
  var deviceUniqueId = getCookie(DEVICE_UNIQUE_ID)
  if (deviceUniqueId === null || deviceUniqueId === undefined || deviceUniqueId.length === 0){
    deviceUniqueId = uuidv4()
    setCookie(DEVICE_UNIQUE_ID, deviceUniqueId, 9999)
  }
  return deviceUniqueId
}